var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { ACCOUNT_CHECKOUT, APP_STORE } from '@/stores/defs';
import { EServiceType } from '@/models/interfaces/Orders/EServiceType';
import Features from '@/utils/Features';
var serviceMixin = {
    computed: __assign({}, mapGetters({
        getServiceType: ACCOUNT_CHECKOUT.GET_SERVICE_TYPE,
        getFeatureFlag: APP_STORE.GET_FEATURE,
    }), { getDefaultServiceType: function () {
            var serviceType = this.getServiceType;
            return serviceType || EServiceType.SERVICE_TYPE_TAKEOUT;
        },
        serviceName: function () {
            var service = this.getServiceType;
            var resolveServiceName = this.resolveServiceName(service);
            return resolveServiceName;
        },
        isForPickup: function () {
            var service = this.getServiceType;
            var forPickup = EServiceType.SERVICE_TYPE_PICKUP;
            var forTakeout = EServiceType.SERVICE_TYPE_TAKEOUT;
            return (service === forPickup || service === forTakeout);
        },
        isForDelivery: function () {
            var service = this.getServiceType;
            var forDelivery = EServiceType.SERVICE_TYPE_DELIVERY;
            return (service === forDelivery);
        },
        service_useVerb: function () {
            var forDelivery = this.isForDelivery;
            return (forDelivery) ? 'to' : 'at';
        },
        service_isDeliveryEnabled: function () {
            return !!this.getFeatureFlag(Features.DELIVERY);
            // TODO use lodash built-in "get" for deeply nested properties
            // const deliveryServiceEnabled = get(
            // 	this.$appConstants,
            // 	'service.delivery.enabled',
            // 	false
            // );
            // return deliveryServiceEnabled;
        } }),
    methods: __assign({}, mapActions({
        setServiceType: ACCOUNT_CHECKOUT.SET_SERVICE_TYPE,
    }), { setServiceTakeout: function () {
            var takeout = EServiceType.SERVICE_TYPE_TAKEOUT;
            this.setServiceType(takeout);
        },
        setServiceDelivery: function () {
            var delivery = EServiceType.SERVICE_TYPE_DELIVERY;
            this.setServiceType(delivery);
        },
        setServiceDineIn: function () {
            var dineIn = EServiceType.SERVICE_TYPE_SEATED;
            this.setServiceType(dineIn);
        },
        resolveServiceName: function (service) {
            var nameMap = {};
            nameMap[EServiceType.SERVICE_TYPE_TAKEOUT] = 'Pickup';
            nameMap[EServiceType.SERVICE_TYPE_DELIVERY] = 'Delivery';
            nameMap[EServiceType.SERVICE_TYPE_SEATED] = 'Dine-in';
            return nameMap[service];
        },
        // TODO determine convention for service type names
        // and use generalized strategy pattern
        typeFromName: function (serviceName) {
            var typeMap = {};
            typeMap['pickup'] = EServiceType.SERVICE_TYPE_TAKEOUT;
            typeMap['takeout'] = EServiceType.SERVICE_TYPE_TAKEOUT;
            typeMap['delivery'] = EServiceType.SERVICE_TYPE_DELIVERY;
            typeMap['dine-in'] = EServiceType.SERVICE_TYPE_SEATED;
            return typeMap[serviceName.toLowerCase()];
        },
        _mapServiceFunctions: function (serviceType) {
            var functionMap = {};
            functionMap['delivery'] = this.setServiceDelivery;
            functionMap['takeout'] = this.setServiceTakeout;
            functionMap['dine-in'] = this.setServiceDineIn;
            return functionMap[serviceType];
        } }),
};
export default serviceMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/serviceMixin.ts
// module id = qOrL
// module chunks = 18